import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import {
    getTemplateLanguageLabel,
    getTemplateTypeLabel,
} from '../../../templates/helpers';

const CustomTemplateColumns = () => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    const nameColumn = [
        {
            align: 'left',
            field: 'title',
            flex: 1,
            headerName: t('Name'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box display="flex" flexDirection="column">
                        <Typography fontWeight="bold" variant="caption">
                            {row.title}
                        </Typography>
                        <Typography variant="caption">
                            {row.pages}{' '}
                            {t('Sheet', { count: row.pages.length })}
                        </Typography>
                    </Box>
                );
            },
            sorteable: false,
        },
    ];

    let columns = [
        ...nameColumn,
        {
            align: 'left',
            field: 'type',
            headerName: t('Type'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {getTemplateTypeLabel(row?.type) || '---'}
                    </Typography>
                );
            },
            sorteable: false,
            width: 300,
        },
        {
            align: 'left',
            field: 'language',
            headerName: t('Language'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {getTemplateLanguageLabel(row?.language) || '---'}
                    </Typography>
                );
            },
            sorteable: false,
            width: 300,
        },
        {
            align: 'left',
            field: 'created_at',
            headerName: t('Creation date'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
            sorteable: false,
            width: 200,
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    return columns;
};

CustomTemplateColumns.propTypes = {
    languagesDictionary: PropTypes.object,
};

export default CustomTemplateColumns;
